import * as services from 'services/download.service';
import * as types from 'constants/downloadsActionTypes';
import { adapterDownloadData, adapterLinkData } from 'adapters/adapterDownloadData';
import { showAlert } from './alert.actions';

export const getAllDownloads = () => async (dispatch) => {
  dispatch({ type: types.GET_LIST_DOWNLOADS_LOADING });
  try {
    const response = await services.fetchDownloads();
    dispatch({
      type: types.GET_LIST_DOWNLOADS_SUCCESS,
      payload: adapterDownloadData(response.data)
    });
    return { success: true, response: response.data };
  } catch (error) {
    dispatch({ type: types.GET_LIST_DOWNLOADS_FAILURE, error });
    return { success: false, response: error };
  }
};

export const getFolioDescarga = (data) => async (dispatch) => {
  try {
    const response = await services.fetchFolioDescarga(data);
    return { success: true, response };
  } catch (error) {
    dispatch(showAlert('Error al agregar a la cola de descarga.', 'error'));
    return { success: false, response: error };
  }
};

export const getArchivoDescarga = (data) => async (dispatch) => {
  try {
    const response = await services.fetchDescargaArchivos(data);
    return { success: true, response };
  } catch (error) {
    dispatch(showAlert('Error al obtener el archivo.', 'error'));
    return { success: false, response: error };
  }
};

export const getAllLinks = () => async (dispatch) => {
  dispatch({ type: types.GET_LIST_LINKS_LOADING });
  try {
    const response = await services.fetchLinks();
    dispatch({
      type: types.GET_LIST_LINKS_SUCCESS,
      payload: adapterLinkData(response.data)
    });
    return { success: true, response: response.data };
  } catch (error) {
    dispatch({ type: types.GET_LIST_LINKS_FAILURE, error });
    return { success: false, response: error };
  }
};

export const getFolioEnlaces = (data) => async (dispatch) => {
  try {
    const response = await services.fetchFolioEnlaces(data);
    return { success: true, response };
  } catch (error) {
    dispatch(showAlert('Error al agregar a la cola de generación de enlaces.', 'error'));
    return { success: false, response: error };
  }
};
